import { BranchDto, BranchDtoRead } from '@/rtkApi/mddApiSliceGeneratedV2'
import { toLocaleDateString } from '@/utils/numbers'

import { BranchRecord } from './types'

export const mapBranchDto = (
	dto: BranchDtoRead,
	systemName: string,
): BranchRecord => ({
	id: String(dto.id ?? ''),
	name: dto.name ?? '',
	status: dto.status ?? 'ACTIVE',
	system: systemName,
	sourceBranchId:
		dto.sourceBranch?.id != null ? String(dto.sourceBranch.id) : null,
	sourceBranchName: dto.sourceBranch?.name ?? dto.sourceBranch?.code ?? null,
	sourceReleaseId: dto.sourceReleaseId ?? null,
	description: dto.description ?? '',
	protectedBranch: Boolean(dto.protectedBranch),
	createdBy: dto.createdBy ?? '',
	createdAt: toLocaleDateString(dto.createdAt),
	updatedBy: dto.updatedBy ?? '',
	updatedAt: toLocaleDateString(dto.updatedAt),
	requiredApprovals: dto.requiredApprovals,
	selfApprovalAllowed: dto.selfApprovalAllowed,
	requireExplicitMergeAction: dto.requireExplicitMergeAction,
	restrictToExplicitPermissions: dto.restrictToExplicitPermissions,
})

export const toBranchUpdateDto = (
	branch: BranchRecord,
	patch: Partial<BranchDto> = {},
): BranchDto => ({
	name: branch.name,
	description: branch.description || undefined,
	protectedBranch: Boolean(branch.protectedBranch),
	restrictToExplicitPermissions: Boolean(branch.restrictToExplicitPermissions),
	requiredApprovals: branch.requiredApprovals,
	selfApprovalAllowed: branch.selfApprovalAllowed,
	requireExplicitMergeAction: branch.requireExplicitMergeAction,
	...patch,
})
